import { useAuthorization } from '../contexts/AuthorizationContext';

/**
 * Authorization wrapper that uses the real AuthorizationContext
 * This provides actual permission checking based on user roles and privileges
 */
export const useAuthorizationWrapper = () => {
  const authorizationContext = useAuthorization();
  
  return authorizationContext;
};
